import { ItemScoreDiamond } from "@/design-system/ItemScore/ItemScoreDiamond";

/** A Streamline set's points target, shown ahead of the coin price it sits beside. */
export const PointsPrice = ({
  points,
  size = 16,
  className,
}: {
  points: number;
  size?: number;
  className?: string;
}) => (
  <div className="flex items-center gap-x-1 mr-1">
    <ItemScoreDiamond size={size} />
    <span className={className}>{points.toLocaleString()}</span>
  </div>
);
